// extracted by mini-css-extract-plugin
module.exports = {"relative":"LineChart__relative___2pVB1","text":"LineChart__text___1IhtF","fullWidth":"LineChart__fullWidth___3Yiq0","minHeight":"LineChart__minHeight___2_-Vd"};